import type { ISingleOrganizationSaml } from "@frontend-shared/types";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { authApi } from "@/api/services";

// NOTE: NSAI-7736 — the IdP redirect behind an organization's own sign-in link
// (`/auth/sso/<organizationUuid>`). Null for an unknown organization or one
// whose SAML is not configured. A one-time lookup, like the single-organization
// one: refetching would only mint another AuthnRequest.
export const useOrganizationSaml = (
  organizationUuid: string | undefined,
): UseQueryResult<ISingleOrganizationSaml | null> => {
  return useQuery({
    queryKey: ["organization-saml", organizationUuid],
    queryFn: () =>
      authApi.getOrganizationSaml({ organizationUuid: organizationUuid ?? "" }),
    enabled: Boolean(organizationUuid),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retry: false,
  });
};
